import { useState } from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";

import { Submit } from "../../../../components/FormInputs/Submit";
import { OnSubmitValidationError } from "../../../../utils/OnSubmitValidationError";

import { FlashError } from "../../../../components/FormInputs/FlashError";
import LoginContainer from "newui/features/Auth/components/Login/components/LoginContainer";
import { EmailField } from "newui/features/Auth/components/Login/components/EmailField";
import { forgotPassword } from "newui/features/Auth/auth-api";
import { InfoBox } from "newui/components/IconBox";
import { ReturnToLoginButton } from "./ReturnToLoginButton";

export const ResetPassword = ({ path: _path }) => {
	const [enterEmailVisible, setEnterEmailVisible] = useState(true);
	const [errorMessage, setErrorMessage] = useState(null);
	let guest = false;
	if (window.location.href.includes("guest")) {
		guest = true;
	}
	const handleSubmit = async (values, setStatus, setSubmitting) => {
		setStatus(null);
		setSubmitting(true);
		try {
			const result = await forgotPassword(values);
			if (result?.status) {
				setEnterEmailVisible(false);
			} else {
				setErrorMessage(result?.message ?? 'An unexpected error occurred, please try again.');
				setStatus("error");
			}
		} catch (e) {
			setStatus("error", 'An unexpected error occurred, please try again.');
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<LoginContainer additionalHeadingText={enterEmailVisible ? '' : 'Reset Link Sent'} welcomeOverrideText="Forgot Your Password">
			{enterEmailVisible ? (
				<>
					<p className="pb-2">
						A link to reset your password can be sent to your email. Enter
						your email below.
					</p>

					<Formik
						enableReinitialize
						initialValues={{ email: "" }}
						validationSchema={Yup.object({
							email: Yup.string().email().required(),
						})}
						onSubmit={(values, { setStatus, setSubmitting }) => {
							handleSubmit(values, setStatus, setSubmitting);
						}}
					>
						{(props) => {
							const { setFieldValue, isSubmitting, status, setStatus } =
								props;
							const onSubmitValidationError = () => {
								setStatus("required");
							};

							return (
								<Form>
									<div className="row">
										<EmailField emailDataTestid="reset-email" setFieldValue={setFieldValue} />
										<div className="col xl-12">
											{status && (
												<FlashError
													heading={errorMessages[status].heading}
													text={errorMessages[status].description ?? errorMessage}
													margin={1}
												/>
											)}
										</div>
										<div className="col xl-12">
											<Submit
												type="submit"
												widthExpand
												marginTop="32px"
												isSubmitting={isSubmitting}
												text="Send Recovery Email"
												submittingText="Sending..."
											/>
										</div>
									</div>
									<OnSubmitValidationError
										callback={onSubmitValidationError}
									/>
								</Form>
							);
						}}
					</Formik>
				</>
			) : (
				<InfoBox>
					<p>
						If an account exists with the provided email address, a password reset link has be sent to it.
					</p>
					<p className="py-2">
						Please check your inbox to reset your password.
					</p>
				</InfoBox>
			)}
			<ReturnToLoginButton isLoading={false} />
		</LoginContainer>
	);
};

const errorMessages = {
	error: {
		heading: "Error",
		description: null,
	},
	required: {
		heading: "* Required Field",
		description: "There are incomplete required fields. Please complete them.",
	},
};
